import GeneralMessageModal from "@/components/Modals/GeneralMessageModal";
import { endpoints } from "@/hooks/endpoints";
import { getToken, isTeacher } from "@/hooks/utils";
import { pushModal } from "@/store/slices/modalsSlice";
import { invokePortalRefetch } from "@/store/slices/storeSlice";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useAppDispatch } from "../../../store/hooks";
import styles from "./TutorLiveScreen.module.css";

const LiveSessionTimer = ({
  startDate,
  sessionId,
  sessionEnded,
  sessionDuration,
  endCall,
}: {
  startDate: number;
  sessionId?: number;
  sessionEnded?: boolean | null;
  sessionDuration?: number;
  endCall?: () => Promise<void>;
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { schoolgrade, group } = useParams();
  const [time, setTime] = useState(0);

  const handleCloseOnTimeup = useCallback(async () => {
    try {
      if (isTeacher()) {
        await fetch(endpoints.endLiveSession + `?session=${sessionId}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: getToken(),
          },
          method: "GET",
        });
      }
      dispatch(invokePortalRefetch());
      dispatch(
        pushModal(<GeneralMessageModal msg="إنتهى وقت الحصة" btnMsg="حسناً" />)
      );
      await endCall();
    } catch (error) {
      console.error(error);
    } finally {
      navigate("/live");
    }
  }, [sessionId, sessionEnded, dispatch, navigate, schoolgrade, group]);

  useEffect(() => {
    let fallbackDate = new Date().getTime();
    const interval = setInterval(async () => {
      const now = new Date().getTime();
      const distance =
        now - (startDate ? new Date(startDate * 1000).getTime() : fallbackDate);
      if (
        (distance / 1000 > 18000 && sessionId) ||
        sessionEnded ||
        sessionDuration * 60 < distance / 1000
      ) {
        clearInterval(interval);
        await handleCloseOnTimeup();
      }
      setTime(distance / 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, [sessionId]);

  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time - hours * 3600) / 60);
  const seconds = Math.floor(time - hours * 3600 - minutes * 60);

  return (
    <span className={styles.timer}>{`${hours
      .toString()
      .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`}</span>
  );
};

export default LiveSessionTimer;
